// Format date to show relative time (Today, Yesterday) or full date
export const formatChatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  // Check if the date is today
  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  }
  
  // Check if the date is yesterday
  if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  }
  
  // For other dates, return the full date
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Format time in 12-hour format with AM/PM
export const formatChatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

// Check if we should show a date separator between two messages
export const shouldShowDateSeparator = (currentMsg, prevMsg) => {
  if (!prevMsg) return true; // First message
  
  const currentDate = new Date(currentMsg.timestamp);
  const prevDate = new Date(prevMsg.timestamp);
  
  return currentDate.toDateString() !== prevDate.toDateString();
};
